<template>
  <div>
    <b-card title="Out Clinic Recite Form">
      <b-row>
        <b-col md="6" cols="12">
          <b-form-group label="Patient Name" label-for="Name">
            <b-form-input
              id="Name"
              v-model="addForm.name"
              placeholder="Enter Patient Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Amount" label-for="Amount">
            <b-form-input
              id="Amount"
              type="number"
              v-model="addForm.amount"
              placeholder="Enter Patient Amount"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Reciever Name" label-for="reciever">
            <b-form-input
              id="reciever"
              v-model="addForm.recieverName"
              placeholder="Enter Reciever Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="On Account" label-for="account">
            <b-form-input
              id="account"
              v-model="addForm.onAccount"
              placeholder="Enter Nurse Name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group label="Date" label-for="Date">
            <datepicker
              v-model="addForm.date"
              :calendar-button="true"
              :clear-button="true"
              :bootstrap-styling="true"
              class="datebtn2"
              placeholder="YYYY-MM-DD"
            ></datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-col
        cols="12"
        md="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-button
          style="margin: auto"
          variant="primary"
          @click="printOutClinicRecite()"
        >
          Print Out Clinic Recite Form
          <b-icon-person-check class="ml-1"></b-icon-person-check>
        </b-button>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import VueHtml2pdf from 'vue-html2pdf';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    VueHtml2pdf,
    Datepicker,
  },

  data() {
    return {
      addForm: {
        amount: '',
        name: '',
        onAccount: '',
        recieverName: '',
        date: '',
      },
      errorForm: {
        name: '',
        age: '',
        surgonName: '',
        nurseName: '',
        assistantName: '',
        unknown: '',
      },
    };
  },
  methods: {
    printOutClinicRecite() {
      //
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>
